import { useCallback, useMemo } from 'react';

import { useRouter } from 'next/router';

import { useSessionDetail, useSessionActions } from '@techstyle/redux-core';

import { useMembership } from './useMembership';

export function useGshop() {
  const sessionActions = useSessionActions();
  const router = useRouter();
  const promo = router?.query?.promo || '';

  const isGshopInSessionDetails = useSessionDetail('GSHOP')?.value === true;

  const isGshopActive = useMemo(
    () => isGshopInSessionDetails,
    [isGshopInSessionDetails]
  );
  const { isVip } = useMembership();
  const isGshopInQuery = promo.toLowerCase().includes('gshop');

  const activateGshop = useCallback(() => {
    if (isGshopInQuery && !isVip) {
      sessionActions.updateSessionDetail({
        name: 'GSHOP',
        value: true,
      });
    }

    // deactivate GSHOP in sessionDetail and customerDetail once customer signs up for VIP
    if (isGshopActive && isVip) {
      sessionActions.updateSessionDetail({
        name: 'GSHOP',
        value: false,
      });
    }
  }, [isGshopInQuery, isVip, sessionActions, isGshopActive]);

  return {
    isGshopActive,
    activateGshop,
  };
}
